import { DATA_BINDING } from '@wix/app-definition-ids'
import { ComponentTypes } from '@wix/wix-data-client-common-standalone'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { ComponentRef } from '@wix/editor-platform-sdk-types'

const APP_WIDGET_VIEWER_TYPE = 'platform.components.AppWidget'
const REF_COMPONENT_VIEWER_TYPE = 'wysiwyg.viewer.components.RefComponent'

export function isAppWidget(viewerType: string) {
  return APP_WIDGET_VIEWER_TYPE === viewerType
}

export function isRefComponent(viewerType: string) {
  return REF_COMPONENT_VIEWER_TYPE === viewerType
}

export function isAppController(sdkType: string) {
  return sdkType === ComponentTypes.AppController
}

export function isDataset(sdkType: string, applicationId?: string) {
  return isAppController(sdkType) && applicationId === DATA_BINDING
}

export async function getComponentApplicationId(
  editorSdkProxy: EditorSDK,
  componentRef: ComponentRef,
): Promise<string | undefined> {
  const componentData: any = await editorSdkProxy.components.data.get({
    componentRef,
  })
  return componentData?.applicationId
}
